document.addEventListener('DOMContentLoaded', function() {
    const $ = jQuery;

    $( "form.list-form select" ).selectmenu({
        position: { my: "left top", at: "left bottom", collision: "none" },
        icons: { button: '' },
        change: (event, ui) => {
            event.target.dispatchEvent(new Event('change'));
            const $currentButton = $('#' + event.target.id + '-button');
            const activeElementId = $currentButton.attr('aria-activedescendant');
            const $selectDropdown = $('#' + event.target.id + '-menu');
            $('.selected', $selectDropdown).removeClass('selected');
            $('#' + activeElementId).addClass('selected');
        },
        open: (event, ui) => {
            const $currentButton = $('#' + event.target.id + '-button');
            const activeElementId = $currentButton.attr('aria-activedescendant');
            const $selectDropdown = $('#' + event.target.id + '-menu');
            $('.selected', $selectDropdown).removeClass('selected');
            $('#' + activeElementId).addClass('selected');
        },
        create: function( event, ui ) {
            const $currentButton = $('#' + event.target.id + '-button');
            let isOpen = false

            $currentButton.on('keydown', function (e) {
                e.stopPropagation();
                if (e.which === 13) {
                    isOpen = !isOpen
                    if (!isOpen) {
                        $(event.target).selectmenu("close");
                    } else {
                        $(event.target).selectmenu("open");
                    }
                }
            });
        }
    });
});